import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { FiArrowRight, FiHome } from 'react-icons/fi';
import orzelKsiazkaIcon from '../../img/icons/orzel_ksiazka.png';
import { overlayVariants, modalVariants } from './surefireFeedback';

const SurefireBatchEndPopup = ({ isOpen, atomName, onContinue, onFinish, isLoading, unitLabel = 'Pewniaka' }) => {
    const reduced = useReducedMotion();
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[9990] flex items-center justify-center px-4">
                    <motion.div
                        variants={overlayVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
                    />
                    <motion.div
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="relative z-[9991] bg-white w-full max-w-sm rounded-2xl p-6 shadow-[0_8px_30px_-5px_rgba(35,56,85,0.15)] border border-gray-100 text-center overflow-hidden"
                    >
                        <div className="flex justify-center mb-2">
                            <motion.img
                                initial={reduced ? false : { scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
                                src={orzelKsiazkaIcon}
                                alt="Koniec paczki"
                                className="h-24 object-contain drop-shadow-xl"
                            />
                        </div>

                        <div className="mb-5">
                            <motion.h2
                                initial={reduced ? false : { opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3 }}
                                className="text-2xl font-bold font-apotek tracking-wider uppercase text-[#233855] mb-2"
                            >
Dobra Robota!
                            </motion.h2>
                            <motion.p
                                initial={reduced ? false : { opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.5 }}
                                className="text-sm text-gray-500 leading-relaxed px-2"
                            >
                                                                Zrobiłaś/eś dużo zadań{atomName ? ` z ${unitLabel} "${atomName}"` : ''}
. Może zrobisz sobie przerwę na inne zadania?
                            </motion.p>
                        </div>

                        <motion.div
                            initial={reduced ? false : { opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6 }}
                            className="flex flex-col gap-3"
                        >
                            <button
                                onClick={onFinish}
                                disabled={isLoading}
                                className="w-full group flex items-center justify-center gap-2 py-3.5 rounded-xl font-bold font-apotek tracking-wider uppercase bg-[#233855] text-white hover:bg-[#1a2b42] shadow-lg shadow-[#233855]/20 transition-all active:scale-[0.98] disabled:opacity-60"
                            >
                                <FiHome size={16} />
                                Wystarczy na dziś
                            </button>
                            <button
                                onClick={onContinue}
                                disabled={isLoading}
                                className="w-full flex items-center justify-center gap-2 py-3 rounded-xl font-bold font-apotek tracking-wider uppercase text-gray-400 hover:text-[#233855] hover:bg-gray-50 border border-gray-200 transition-all active:scale-[0.98] text-sm"
                            >
                                {isLoading ? 'Ładowanie...' : 'Kontynuuj naukę'}
                                {!isLoading && <FiArrowRight className="group-hover:translate-x-1 transition-transform" />}
                            </button>
                        </motion.div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default SurefireBatchEndPopup;
